/**
 * @generated SignedSource<<7c89d4f3ae4bed5699cbb47b6fdd3d97>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MemoriesCardForgetAllMutation$variables = Record<PropertyKey, never>;
export type MemoriesCardForgetAllMutation$data = {
  readonly forgetAllMemories: {
    readonly learner: {
      readonly id: string;
      readonly memories: ReadonlyArray<{
        readonly createdAt: any;
        readonly id: string;
        readonly kind: string;
        readonly text: string;
      }>;
    } | null | undefined;
  };
};
export type MemoriesCardForgetAllMutation = {
  response: MemoriesCardForgetAllMutation$data;
  variables: MemoriesCardForgetAllMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ForgetMemoryPayload",
    "kind": "LinkedField",
    "name": "forgetAllMemories",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnerMemory",
            "kind": "LinkedField",
            "name": "memories",
            "plural": true,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MemoriesCardForgetAllMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MemoriesCardForgetAllMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "4cccc506f73129b8a99aaf146f56718a",
    "id": null,
    "metadata": {},
    "name": "MemoriesCardForgetAllMutation",
    "operationKind": "mutation",
    "text": "mutation MemoriesCardForgetAllMutation {\n  forgetAllMemories {\n    learner {\n      id\n      memories {\n        id\n        kind\n        text\n        createdAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d4282216c4bfbf77674c1376a60d654";

export default node;
